import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
ヘッダー動き
--------------------------------------------------*/
let header = document.querySelector('.header'); // ヘッダー要素を取得
let scrollHandler = null; // スクロールイベントを管理する変数

function updateScrollEvent() {
  // 画面幅が1024px以上の場合にスクロールイベントを追加
  if (window.innerWidth >= 1024) {
    if (!scrollHandler) {
      // スクロールイベントの処理を関数として定義
      scrollHandler = function () {
        let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; // 現在のスクロール位置を取得
        let height = window.innerHeight; // ビューポートの高さを取得
        let threshold = height - 250; // ヘッダーが固定されるスクロール位置の閾値を設定（ビューポートの高さ - 250px）

        // スクロール位置が閾値を超えた場合、ヘッダーに'is_fixed'クラスを追加
        if (scroll > threshold) {
          header.classList.add('is_fixed');
        } else {
          header.classList.remove('is_fixed'); // それ以外の場合、'is_fixed'クラスを削除
        }
      };
      // スクロールイベントを監視
      window.addEventListener('scroll', scrollHandler);
    }
  } else {
    // 画面幅が1024px未満の場合、スクロールイベントを削除
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null; // イベントハンドラを解除
      header.classList.remove('is_fixed'); // 強制的に'is_fixed'クラスを削除
    }
  }
}
// 初回実行（ページロード時にスクロールイベントを設定）
updateScrollEvent();
// ウィンドウのリサイズ時にも適用（画面サイズ変更時に再評価）
window.addEventListener('resize', updateScrollEvent);


/*------------------------------------------------
indexの重なりアニメーション
--------------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function initCardAnimation() {
  // 既存の ScrollTrigger をすべて削除
  ScrollTrigger.getAll().forEach(st => st.kill());

  const section = document.querySelector('.cardSection');
  const cards = document.querySelectorAll('.cardItem');

  // SP以下は完全無効化（重ねない・高さ固定もしない）
  if (!body.classList.contains("home") || window.innerWidth <= 768) {
    // 念のため高さをリセット
    if (section) section.style.height = "auto";
    // カード位置もリセット
    cards.forEach(card => gsap.set(card, { clearProps: "all" }));
    return;
  }

  // ======================
  // PC用の処理 (769px〜)
  // ======================
  const animation = gsap.timeline();
  let cardHeight;
  let totalSpacer;

  function initCards() {
    const buffer = 25;
    const getMb = gsap.getProperty('.index-titles', 'marginBottom');
    const getMt = gsap.getProperty('.index-titles', 'marginTop');

    let getPt = 0;
    if (window.innerWidth <= 1024) {
      getPt = gsap.getProperty('.card', 'marginTop');
    }

    totalSpacer = Math.ceil(getMb + getMt + getPt + buffer);

    animation.clear();
    cardHeight = cards[0].offsetHeight;

    cards.forEach((card, index) => {
      if (index > 0) {
        gsap.set(card, { y: index * cardHeight });
        animation.to(
          card,
          { y: totalSpacer * index, duration: index * 1, ease: 'none' },
          0
        );
      }
    });

    // 最後のカードが見切れるまでの高さを確保
    const lastCard = cards[cards.length - 1];
    const totalHeight = lastCard.offsetTop + lastCard.offsetHeight;
    section.style.height = `${totalHeight}px`;
  }

  initCards();
  window.addEventListener('resize', initCards);

  const headerEl = document.querySelector('.header');
  const headerHeight = headerEl.offsetHeight;

  ScrollTrigger.create({
    trigger: cards[0],
    start: `top top+=${headerHeight}`,
    pin: '.cardSection',
    endTrigger: '.index-news',
    end: 'top top',
    scrub: true,
    animation: animation,
    invalidateOnRefresh: true,
  });

  ScrollTrigger.addEventListener('refreshInit', initCards);
}

// 初期化
initCardAnimation();

// リサイズのたびに再判定
window.addEventListener('resize', () => {
  initCardAnimation();
});



/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');  //ハンバーガーメニューボタン
let nav_box = document.querySelector('.hd_nav_box');  //ハンバーガーメニュー中身
  button.addEventListener('click', function() {   // クリックしたとき


    if(nav_box.classList.contains('is_open') == true){  // .hd_nav_box　に　is_openクラスがついてたら

      nav_box.classList.remove("is_open");  //　メニュー表示　のクラスを削除　中身が見えない
      button.classList.remove("is_close");  //　閉じるボタン　のクラスを削除　元の三本線

    }else{

      nav_box.classList.add("is_open"); //　メニュー表示　のクラスをつける　中身が見える
      button.classList.add("is_close"); //　閉じる表示ボタン　のクラスをつける　×表示
    }
  });

/*------------------------------------------------
グリーンタイトルアニメーション
--------------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function splitTextToSpans(el) {
  const text = el.textContent;
  el.innerHTML = text
    .split('')
    .map(char => `<span style="display:inline-block; opacity:0; transform:translateX(30px)">${char}</span>`)
    .join('');
}

const titles = document.querySelectorAll('.cmn_title.anime');

titles.forEach(title => {
  const titleJa = title.parentElement.querySelector('.cmn_title_ja.anime');
  if (!titleJa) return;

  splitTextToSpans(title);
  splitTextToSpans(titleJa);

  const titleSpans = title.querySelectorAll('span');
  const titleJaSpans = titleJa.querySelectorAll('span');

  const maxLength = Math.max(titleSpans.length, titleJaSpans.length);

  ScrollTrigger.create({
    trigger: title,
    start: 'top 70%',
    onEnter: () => {
      for (let i = 0; i < maxLength; i++) {
        const englishSpan = titleSpans[i];
        const japaneseSpan = titleJaSpans[i];
        const targets = [];
        if (englishSpan) targets.push(englishSpan);
        if (japaneseSpan) targets.push(japaneseSpan);

        gsap.to(targets, {
          opacity: 1,
          x: 0,
          duration: 0.6,
          ease: 'power2.out',
          delay: i * 0.05
        });
      }
    }
  });
});


/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    gsap.registerPlugin(ScrollToPlugin);

    const urlHash = location.hash;

    // デフォルトジャンプを防止
    window.scrollTo(0, 0);

    // 少し待ってからGSAPでスクロール
    setTimeout(() => {
      gsap.to(window, {
        duration: 0.8,
        scrollTo: {
          y: urlHash,
          offsetY: 100 // ← 常に100px余裕を持たせる
        },
        ease: "power2.out"
      });
    }, 100);
  }
});

/*----------------------------------------
慣性スクロール
------------------------------------------*/
if (window.innerWidth > 768) { //pcのみ発動
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
}

/*----------------------------------------
要素アニメーション
------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".scrollAnim");

  // 初期状態で ready クラスを付与
  elements.forEach(el => el.classList.add("ready"));

  const cb = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target); // 一度だけ発火させる場合
      }
    });
  };

  const options = {
    root: null, // ビューポート基準
    rootMargin: "-50% 0px 0px 0px", // 上から30%下がった位置で判定
    threshold: 0
  };

  const io = new IntersectionObserver(cb, options);

  elements.forEach(el => io.observe(el));
});

/*----------------------------------------
お知らせ 日付デザイン
------------------------------------------*/
document.querySelectorAll(".index-news_time").forEach(el => {
  const text = el.textContent.trim();
  const [year, month, day] = text.split(".");

  el.innerHTML = `
    <span class="year">${year}</span>
    <span class="date">${month}.${day}</span>
  `;
});

/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


/*----------------------------------------
お問い合わせプルダウン　重複防止
------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const selects = document.querySelectorAll(
    'select[name="select-1"], select[name="select-2"], select[name="select-3"]'
  );

  function updateOptions() {
    const chosen = Array.from(selects)
      .map(s => s.value)
      .filter(v => v !== "" && v !== "プルダウンからお選びください");

    selects.forEach(select => {
      const current = select.value;

      Array.from(select.options).forEach((opt, i) => {
        // プレースホルダーは常に選択可能（disabled/hiddenにしない）
        if (i === 0 || opt.value === "プルダウンからお選びください") {
          opt.disabled = false;
          opt.hidden = false;
          return;
        }

        // 他で選ばれている値は非表示
        opt.hidden = chosen.includes(opt.value) && opt.value !== current;

        // 選択肢の文字色は常に黒
        opt.style.color = "#333333";
      });

      // 選択中の文字色を切り替え
      if (current === "" || current === "プルダウンからお選びください") {
        select.style.color = "#33333380"; // 薄い色
      } else {
        select.style.color = "#333333"; // 通常色
      }
    });
  }

  selects.forEach(select => {
    select.addEventListener("change", updateOptions);
    select.addEventListener("click", updateOptions);
  });

  updateOptions();
});



/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

